export const assessmentTemplate = [
  {
    omniAudit: {
      auditVersion: 1,
      omniRevision: 1,
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: 1,
      writtenBy: null,
      createdBy: "melissaadmin9999",
      createdDate: "2024-20-21T00:00:00Z",
      modifiedBy: "melissaadmin9999",
      modifiedDate: "2024-24-21T00:00:00Z",
      isActive: true,
    },
    omniData: {
      omniType: "omniMedicationTrack",
      omniTypeVersion: 1,
      title: "Medication Tracking",
      purpose: "Tracking medication compliance",
      description: "Medication Tracking",
      duration: "Around 5 minutes",
      directions: "Follow the onscreen instructions after you begin.",
      attribution: "",
      validated: true,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "mt1",
          shortTitle: "subjectMedicationTaken",
          numberText: 1,
          text: "Have you taken your medication today?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: false,
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "mt2",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "mt1a",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mt1a",
          shortTitle: "subjectNonComplianceReason",
          numberText: 2,
          text: "Why didn't you take your medication? Select all reasons that apply.",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: true,
          answerOptions: [
            {
              value: "notworking",
              text: "Medication not working",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "badSideEffects",
              text: "Side effects",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "financialReason",
              text: "Too expensive",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "noRefill",
              text: "Ran out of medication",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "depression",
              text: "Too depressed",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "other",
              text: "Something else",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mt2",
          shortTitle: "subjectGeneralFeeling",
          numberText: 3,
          text: "How are you feeling today?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "numberScale",
          multiSelectText: false,
          answerOptions: [
            {
              value: 0,
              text: 0,
              subText: "Terrible",
              helpText: "",
              nextQuestionID: "ms1",
              isLast: false,
            },
            {
              value: 1,
              text: 1,
              subText: "",
              helpText: "",
              nextQuestionID: "ms1",
              isLast: false,
            },
            {
              value: 2,
              text: 2,
              subText: "",
              helpText: "",
              nextQuestionID: "ms1",
              isLast: false,
            },
            {
              value: 3,
              text: 3,
              subText: "OK",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 4,
              text: 4,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 5,
              text: 5,
              subText: "Great",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ms1",
          shortTitle: "subjectDepression",
          numberText: 1,
          text: "Please rate your depression today.",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "sliderScale",
          multiSelectText: false,
          answerOptions: [
            {
              value: 0,
              text: 0,
              subText: "No depression at all",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 1,
              text: 1,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 2,
              text: 2,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 3,
              text: 3,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 4,
              text: 4,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 5,
              text: 5,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 6,
              text: 6,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 7,
              text: 7,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 8,
              text: 8,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 9,
              text: 9,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 10,
              text: 10,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ms2",
          shortTitle: "subjectPain",
          numberText: 2,
          text: "How would you rate your pain today?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "sliderScale",
          multiSelectText: false,
          answerOptions: [
            {
              value: 0,
              text: 0,
              subText: "No pain at all",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 1,
              text: 1,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 2,
              text: 2,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 3,
              text: 3,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 4,
              text: 4,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 5,
              text: 5,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 6,
              text: 6,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 7,
              text: 7,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 8,
              text: 8,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 9,
              text: 9,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 10,
              text: 10,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ms3",
          shortTitle: "subjectMemoryCognition",
          numberText: 3,
          text: "How is your memory today?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "sliderScale",
          multiSelectText: false,
          answerOptions: [
            {
              value: 0,
              text: 0,
              subText: "No memory problems at all",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 1,
              text: 1,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 2,
              text: 2,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 3,
              text: 3,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 4,
              text: 4,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 5,
              text: 5,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 6,
              text: 6,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 7,
              text: 7,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 8,
              text: 8,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 9,
              text: 9,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 10,
              text: 10,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ms4",
          shortTitle: "subjectFatigue",
          numberText: 4,
          text: "Please rate your current level of fatigue.",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "sliderScale",
          multiSelectText: false,
          answerOptions: [
            {
              value: 0,
              text: 0,
              subText: "No fatigue at all",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 1,
              text: 1,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 2,
              text: 2,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 3,
              text: 3,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 4,
              text: 4,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 5,
              text: 5,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 6,
              text: 6,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 7,
              text: 7,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 8,
              text: 8,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 9,
              text: 9,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: 10,
              text: 10,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ms5",
          shortTitle: "subjectDifficultyWalking",
          numberText: 4,
          text: "Please rate any difficulty walking?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "sliderScale",
          multiSelectText: false,
          answerOptions: [
            {
              value: 0,
              text: 0,
              subText: "No difficulties walking at all",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 1,
              text: 1,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 2,
              text: 2,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 3,
              text: 3,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 4,
              text: 4,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 5,
              text: 5,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 6,
              text: 6,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 7,
              text: 7,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 8,
              text: 8,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 9,
              text: 9,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: 10,
              text: 10,
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "omniMSOnboard",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
